import React, {useEffect, useState} from 'react';
import {apiPath, serverToken} from "../../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";
import CustomPagination from "../../components/CustomPagination";
import astronaut from "../../anim/astronaut.json";
import Lottie from "lottie-react";
import {useNavigate} from "react-router-dom";
import Hashids from "hashids";

function Users() {

    const navigate = useNavigate()

    const hashids = new Hashids('', 10)

    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState(null);
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [show, setShow] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {

        const fetchUsers = async (page) => {
            setIsLoading(true);

            const headers = {
                'Authorization': serverToken,
            };

            const res = await axios.get(apiPath + '/admin-users?page=' + page, {headers});
            setUsers(res.data.container.data);
            setData(res.data.container)
            setIsLoading(false);
        }

        fetchUsers(currentPage)

    }, [currentPage]);

    if (!users) {
        return (
            <div className="container mx-auto flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    if (users.length === 0) {
        return (
            <div className="container mx-auto h-screen flex flex-col justify-center items-center">
                <Lottie className="w-full lg:w-1/3" animationData={astronaut} loop={true}/>
                <p className="py-5">No hay nada para mostrar</p>
            </div>
        );
    }

    // Change page
    const paginateFront = () => setCurrentPage(currentPage + 1);
    const paginateBack = () => setCurrentPage(currentPage - 1);


    const handelDeleteModal = (showModal, userData) => {
        setShow(showModal);
        setSelectedUser(userData)
    }

    const handelEditModal = (userID) => {
        navigate('/actualizar-billetera/' + hashids.encode(userID))
    }

    const handelDeleteAccount = () => {

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/delete-account/' + selectedUser.id, {headers})
            .then(data => {
                setIsLoading(true);
            })
            .catch(error => {
                // console.log(error);
            });

        setShow(!show);
    }

    const handleUpdateAccountStatus = (id) => {

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/update-account-status/' + id, {headers})
            .then(data => {
                setIsLoading(true);
            })
            .catch(error => {
                //console.log(error);
            });
    }

    return (
        <div className="px-4 pb-5 overflow-y-auto bg-white rounded-lg">

            <table className="w-full whitespace-nowrap ">
                <thead>
                <tr className="h-16 w-full text-sm leading-none text-gray-800">
                    <th className="font-normal text-left ">Cliente</th>
                    <th className="font-normal text-left ">Teléfono</th>
                    <th className="font-normal text-left ">Billetera</th>
                    <th className="font-normal text-left ">Estado</th>
                    <th className="font-normal text-left ">Acciones</th>
                </tr>
                </thead>
                <tbody className="w-full">
                {users.map((user) => {
                    return (
                        <tr key={user.id}
                            className="h-20 text-sm leading-none text-gray-800 bg-white hover:bg-gray-50 border-b border-t border-gray-100">
                            <td className="pl-4">
                                <div className="flex items-center">
                                    <div className="w-10 h-10">
                                        <img className="w-full h-full rounded"
                                             src={user.avatar !== "null" ? user.avatar : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909__340.png"}
                                             alt=""/>
                                    </div>
                                    <div className="px-4">
                                        <div className="flex items-center">
                                            <p className="font-medium">{user.name}</p>

                                            {user.role === 'A'
                                                ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                       fill="currentColor" className="w-4 h-4 text-sky-400">
                                                    <path fillRule="evenodd"
                                                          d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                                :
                                                <>
                                                </>
                                            }

                                        </div>

                                        <p className="text-xs leading-3 text-gray-600 pt-2">{user.email}</p>
                                    </div>
                                </div>
                            </td>
                            <td className="text-start  px-4 lg:px-0">
                                <p className="text-sm leading-none text-gray-800">{user.phone !== "empty" ? user.phone : "No disponible"}</p>
                            </td>

                            <td className="text-center  px-4 lg:px-0">
                                <p className="text-sm leading-none text-gray-800">{user.wallet} CUP</p>
                            </td>

                            <td className="text-center px-4 lg:px-0">

                                {user.active !== 1 ?
                                    <button onClick={() => handleUpdateAccountStatus(user.id)}><span
                                        className="rounded-full px-3 py-1 mt-2 bg-red-50 text-red-400 text-xs font-normal">Desactivado</span>
                                    </button>
                                    :
                                    <button onClick={() => handleUpdateAccountStatus(user.id)}><span
                                        className="rounded-full px-3 py-1 mt-2 bg-green-50 text-green-400 text-xs font-normal">Activo</span>
                                    </button>
                                }
                            </td>

                            <td className="text-center mt-7 px-4 lg:px-0 flex flex-row  space-x-3">

                                <button onClick={() => handelEditModal(user.id)}
                                        className="text-sm text-gray-600 hover:text-sky-400">Editar
                                </button>

                                <button onClick={() => handelDeleteModal(true, user)}
                                        className="text-sm text-gray-600 hover:text-sky-400">Eliminar
                                </button>


                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>

            <CustomPagination
                currentPage={data.current_page}
                paginateBack={paginateBack}
                paginateFront={paginateFront}
                postsPerPage={data.per_page}
                totalPosts={data.last_page}
                current={users.length}
                totalUsers={data.total}
            />

            <>
                {show && <div
                    className="py-12 bg-gray-700 dark:bg-gray-900 transition duration-150 ease-in-out z-10 absolute top-0 right-0 bottom-0 left-0"
                    id="modal">
                    <div role="alert" className="container mx-auto w-11/12 md:w-2/3 max-w-lg">
                        <div
                            className="relative py-8 px-8 md:px-16 bg-white dark:bg-gray-800 dark:border-gray-700 shadow-md rounded border border-gray-400">
                            <div className="w-full flex justify-center text-green-400 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     className="icon icon-tabler icon-tabler-circle-check" width={56} height={56}
                                     viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z"/>
                                    <circle cx={12} cy={12} r={9}/>
                                    <path d="M9 12l2 2l4 -4"/>
                                </svg>
                            </div>
                            <h1 className="text-center text-gray-800 dark:text-gray-100 font-lg font-bold tracking-normal leading-tight mb-4">
                                Eliminar cuenta de {selectedUser.name}
                            </h1>
                            <p className="mb-5 text-sm text-gray-600 dark:text-gray-400 text-center font-normal">¿Está
                                seguro de eliminar esta cuenta?</p>
                            <div className="flex items-center justify-center w-full">
                                <button onClick={() => handelDeleteAccount()}
                                        className="focus:outline-none transition duration-150 ease-in-out hover:bg-sky-300 bg-sky-500 rounded text-white px-4 sm:px-8 py-2 text-xs sm:text-sm">
                                    Confirmar
                                </button>
                                <button
                                    className="focus:outline-none ml-3 bg-gray-100 dark:bg-gray-700 dark:border-gray-700 dark:hover:bg-gray-600 transition duration-150 text-gray-600 dark:text-gray-400 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm"
                                    onClick={() => setShow(!show)}>
                                    Cancelar
                                </button>
                            </div>
                            <div
                                className="cursor-pointer absolute top-0 right-0 mt-4 mr-5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-500 transition duration-150 ease-in-out"
                                onClick={() => setShow(!show)}>
                                <svg xmlns="http://www.w3.org/2000/svg" aria-label="Close"
                                     className="icon icon-tabler icon-tabler-x" width={20} height={20}
                                     viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" fill="none"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z"/>
                                    <line x1={18} y1={6} x2={6} y2={18}/>
                                    <line x1={6} y1={6} x2={18} y2={18}/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>}
            </>

        </div>
    );
}

export default Users;

